import { Translation } from 'cng-common/features/translations'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../../configs/translations'
import type { IPartnerDocumentSection } from '../../../../lib/documentsAndLinks'
import { useDocumentsTreeContent } from '../../hooks/useDocumentsTreeContent'
import { DocumentsTreeGroup } from '../documentsTreeGroup/DocumentsTreeGroup'
import { DocumentsTreeSummary } from '../documentsTreeSummary/DocumentsTreeSummary'
import { DocumentsTreeToolbar } from '../documentsTreeToolbar/DocumentsTreeToolbar'

import styles from './DocumentsTreeContent.module.scss'

const KEYS = FINANCIAL_COCKPIT_TRANSLATION_KEYS.documentsAndLinks
export const DocumentsTreeContent = ({
  sections,
  readOnly = true,
}: {
  sections: IPartnerDocumentSection[]
  readOnly?: boolean
}) => {
  const {
    documentType,
    grouping,
    search,
    collapsed,
    countries,
    groups,
    toggle,
    changeType,
    changeGrouping,
    setSearch,
    expandAll,
    collapseAll,
  } = useDocumentsTreeContent(sections)
  return (
    <div className={styles.root}>
      <DocumentsTreeToolbar
        sections={sections}
        documentType={documentType}
        grouping={grouping}
        search={search}
        onTypeChange={changeType}
        onGroupingChange={changeGrouping}
        onSearchChange={setSearch}
      />
      <DocumentsTreeSummary
        grouping={grouping}
        groupCount={groups.length}
        documentCount={groups.reduce((sum, group) => sum + group.rows.length, 0)}
        onExpandAll={expandAll}
        onCollapseAll={collapseAll}
      />
      <div>
        {groups.map((group) => (
          <DocumentsTreeGroup
            key={group.id}
            group={group}
            readOnly={readOnly}
            country={grouping === 'partner' ? countries.get(group.id) : undefined}
            expanded={!collapsed.has(group.id)}
            onToggle={() => toggle(group.id)}
          />
        ))}
        {!groups.length && (
          <Translation span text={documentType === 'elt' ? KEYS.emptyElt : KEYS.emptyQbr} />
        )}
      </div>
    </div>
  )
}
